import * as angular from 'angular';

import { WorkspaceSettingsUiAngularJsModule } from '@mode/workspace-settings/ui-angularjs';
import { CheckboxToggleModule } from './checkbox-toggle/checkbox-toggle.module';
import { CopyToClipboardFieldModule } from './copy-to-clipboard-field/copy-to-clipboard-field.module';
import { FormToggleConfirmComponent } from './form-toggle-confirm/form-toggle-confirm.component';
import { IconSelectFieldComponent } from './icon-select-field/icon-select-field.component';
import { InlineSelectFieldComponent } from './inline-select-field/inline-select-field.component';
import { PaginatorComponent } from './paginator/paginator.component';
import { PanelLoadingComponent } from './panel-loading/panel-loading.component';
import { PanelSectionDetailsComponent } from './panel-section-details/panel-section-details.component';
import { PanelSectionComponent } from './panel-section/panel-section.component';
import { SearchFieldComponent } from './search-field/search-field.component';
import { SearchSelectorModule } from './search-selector/search-selector.module';

/* prettier-ignore */
export const CommonModule = angular
  .module('common', [
    CheckboxToggleModule,
    CopyToClipboardFieldModule,
    SearchSelectorModule,
    WorkspaceSettingsUiAngularJsModule
  ])
  .component('formToggleConfirm', FormToggleConfirmComponent)
  .component('paginator', PaginatorComponent)
  .component('panelLoading', PanelLoadingComponent)
  .component('panelSection', PanelSectionComponent)
  .component('panelSectionDetails', PanelSectionDetailsComponent)
  .component('searchField', SearchFieldComponent)
  .component('iconSelectField', IconSelectFieldComponent)
  .component('inlineSelectField', InlineSelectFieldComponent)
  .name;
